var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 0.166504H2.16667C1.25 0.166504 0.5 0.916504 0.5 1.83317V11.8332C0.5 12.7498 1.25 13.4998 2.16667 13.4998H6.33333V14.3332C6.33333 14.7915 6.70833 15.1665 7.16667 15.1665H12.1667C12.625 15.1665 13 14.7915 13 14.3332V13.4998H17.1667C18.0833 13.4998 18.8333 12.7498 18.8333 11.8332V1.83317C18.8333 0.916504 18.0833 0.166504 17.1667 0.166504ZM16.3333 11.8332H3C2.54167 11.8332 2.16667 11.4582 2.16667 10.9998V2.6665C2.16667 2.20817 2.54167 1.83317 3 1.83317H16.3333C16.7917 1.83317 17.1667 2.20817 17.1667 2.6665V10.9998C17.1667 11.4582 16.7917 11.8332 16.3333 11.8332ZM14.6667 4.33317H7.16667C6.70833 4.33317 6.33333 4.70817 6.33333 5.1665C6.33333 5.62484 6.70833 5.99984 7.16667 5.99984H14.6667C15.125 5.99984 15.5 5.62484 15.5 5.1665C15.5 4.70817 15.125 4.33317 14.6667 4.33317ZM14.6667 7.6665H7.16667C6.70833 7.6665 6.33333 8.0415 6.33333 8.49984C6.33333 8.95817 6.70833 9.33317 7.16667 9.33317H14.6667C15.125 9.33317 15.5 8.95817 15.5 8.49984C15.5 8.0415 15.125 7.6665 14.6667 7.6665ZM5.5 4.33317H3.83333V5.99984H5.5V4.33317ZM5.5 7.6665H3.83333V9.33317H5.5V7.6665Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsyncIcon);
export default __webpack_public_path__ + "static/media/asyncIcon.18a7d77e.svg";
export { ForwardRef as ReactComponent };